import { render, staticRenderFns } from "./FilaRequisicoesTituloSecao.vue?vue&type=template&id=53d4a130&scoped=true"
import script from "./FilaRequisicoesTituloSecao.vue?vue&type=script&lang=js"
export * from "./FilaRequisicoesTituloSecao.vue?vue&type=script&lang=js"
import style0 from "./FilaRequisicoesTituloSecao.vue?vue&type=style&index=0&id=53d4a130&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d4a130",
  null
  
)

export default component.exports